import Image from 'next/image'

interface Props {
  title: string
  description: string
  list: { id: string | number; title: string; description: string }[]
}

function AISearch({ title, description, list }: Props) {
  return (
    <section className="bg-[#090909] text-white relative">
      <Image
        src="/assets/index-25/decode-bg-img.png"
        alt="decode-bg-img"
        height="955"
        width="1441"
        className="absolute w-full h-full object-top"
      />
      <div className="container | relative z-10 mx-auto py-10 md:py-18">
        <div className="max-w-4xl">
          <h2 className="text-4xl md:text-6xl | mb-7 md:mb-10">{title}</h2>
          <p className="text-sm md:text-2xl text-gray-40 tracking-tighter">
            {description}
          </p>
        </div>
        <hr className="border-white | my-14 md:my-22" />
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-10">
          {list.map(value => {
            return (
              <div key={value.id}>
                <h3
                  className="text-xl md:text-2xl font-semibold  | md:max-w-col-4 mb-2 md:mb-6"
                  dangerouslySetInnerHTML={{ __html: value.title }}
                />
                <div
                  className="font-body text-base md:text-xl text-gray-40 | md:max-w-col-4"
                  dangerouslySetInnerHTML={{ __html: value.description }}
                />
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default AISearch
